<template>
    <div ref="printContent" class="xx-print-wrapper xx-print-content">
        <!-- @slot 默认的slot，这里期望的是print-template模块 -->
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'XxPrintTemplateGroup',
    props: {
        /**
         * @Desc: 是否隐藏要打印的元素
         * @type {boolean} hidePrintInfo
         */
        hidePrintInfo: {
            type: Boolean,
            default: true
        },
        /**
         * @Desc: 打印前的回调函数，用于做一些隐藏的打印元素被渲染之后的操作，当返回值为false时会中止打印
         * @type {function} beforePrint
         * @return {(boolean | undefined | promise)} 返回值为false时会中止打印，异步回调需要返回promise
         */
        beforePrint: {
            type: Function,
            default: null
        },
        /**
         * @Desc: 打印后的回调函数
         * @type {function} afterPrint
         */
        afterPrint: {
            type: Function,
            default: null
        },
        printMethod: {
            type: Function,
            default: () => {
                window.print();
            }
        }
    },
    data() {
        return {
            printElement: null,
            isFirstPrint: true
        };
    },
    mounted() {
        this.printElement = this.$refs.printContent;
    },
    methods: {
        /**
         * @Desc: 执行打印的方法
         */
        handlePrint() {
            try {
                // 调用default slot的方法
                this.$slots.default[0].child.handlePrint(this);
            } catch (e) {
                console.error('print-template-group的slot不合法');
            }
        },
        Jsbarcode(...args) {
            try {
                // 调用default slot的方法
                this.$slots.default[0].child.Jsbarcode(...args);
            } catch (e) {
                console.error('print-template-group的slot不合法');
            }
        },
        showElement() {
            if (this.isFirstPrint || !this.hidePrintInfo) {
                document.body.appendChild(this.printElement);
            }
            this.printElement.querySelectorAll('.xx-print-content').forEach(item => {
                item.style.display = 'block';
            });
        },
        handleAfterPrint(nextNode, parentNode) {
            if (this.hidePrintInfo) {
                this.printElement.querySelectorAll('.xx-print-content').forEach(item => {
                    item.style.display = 'none';
                });
            } else {
                document.body.removeChild(this.printElement);
                nextNode ? parentNode.insertBefore(this.printElement, nextNode) : parentNode.appendChild(this.printElement);
            }
            this.isFirstPrint = false;
            this.afterPrint && this.afterPrint();
        }
    }
};
</script>
<style lang="scss" scoped>
.xx-print-wrapper {
    display: block;
}
</style>
